// Palette de 12 cores distinguíveis pra VLAN path mode.
// Mapeamento determinístico vid → color via hash simples (vid % N).
// Garante que a mesma VLAN pega a mesma cor em reload, zoom, etc.

const VLAN_PALETTE = [
  '#f97316', // orange
  '#06b6d4', // cyan
  '#10b981', // emerald
  '#a855f7', // purple
  '#fbbf24', // amber
  '#ef4444', // red
  '#3b82f6', // blue
  '#ec4899', // pink
  '#84cc16', // lime
  '#14b8a6', // teal
  '#f59e0b', // yellow-orange
  '#8b5cf6', // violet
];

/**
 * Cor estável pra um VID. Mesmo VID sempre devolve a mesma cor.
 * VIDs vizinhos (100, 101) ficam em cores distantes via hash com mistura.
 */
export function colorForVid(vid) {
  if (vid == null) return '#94a3b8';
  const n = Number(vid);
  if (!Number.isFinite(n)) return '#94a3b8';
  // Mistura simples: multiplica por número primo grande, mod palette length
  const idx = Math.abs((n * 2654435761) % VLAN_PALETTE.length);
  return VLAN_PALETTE[idx];
}

export { VLAN_PALETTE };
